/* eslint-disable */
export const DifferntiatedProdDevItems = [
  {
    "srno": 1,
    "productID": "2002",
    "rLDProduct_Dev": "XTANDI (USA, EU, Japan)",
    "productName": "Enzalutamide Tablets (40, 80, 120, 160 mg)",
    "productDevStatus": "Done",
    "pilotBE": "Done",
    "scaleUp": "Pending",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Non Infrringing. Pilot BE Ongoing",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 2,
    "productID": "2017",
    "rLDProduct_Dev": "Relistor (USA)",
    "productName": "MethylNaltrexone Bromide Tablets 150 mg",
    "productDevStatus": "Done",
    "pilotBE": "Pending",
    "scaleUp": "Pending",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Ready for Pilot",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 3,
    "productID": "3012",
    "rLDProduct_Dev": "Pentasa Sachets (Ferring UK)",
    "productName": "Mesalamine Extended Release Pellets (Sachets)",
    "productDevStatus": "Done",
    "pilotBE": "Pending",
    "scaleUp": "Pending",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Ready for TT",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": false
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 4,
    "productID": "3014",
    "rLDProduct_Dev": "Procysbi (USA)",
    "productName": "Cysteamine Bitartarate Delayed Release Capsule (25 mg and 75 mg)",
    "productDevStatus": "Ongoing",
    "pilotBE": "Pending",
    "scaleUp": "Pending",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Development Ongoing",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 5,
    "productID": "3024",
    "rLDProduct_Dev": "LINZESS (USA)/ Constella (EU)",
    "productName": "Linaclotide Capsules (72 mcg, 145 mcg, 290 mcg)",
    "productDevStatus": "Done",
    "pilotBE": "N/A",
    "scaleUp": "Pending",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Q1Q2 Done",
    "avaliableIn": [
      {
        "key": "USA",
        "value": false
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": false
      }
    ]
  },
  {
    "srno": 6,
    "productID": "3025",
    "rLDProduct_Dev": "VELTASSA (USA)",
    "productName": "Patiromer Powder For Suspension (1.2 gm, 8.4 gm, 16.8 gm and 25. 2 gm)",
    "productDevStatus": "Done",
    "pilotBE": "N/A",
    "scaleUp": "Pending",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Ready for Tech Transfer",
    "avaliableIn": [
      {
        "key": "USA",
        "value": false
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": false
      }
    ]
  },
  {
    "srno": 7,
    "productID": "3031",
    "rLDProduct_Dev": "Dexilant (USA)",
    "productName": "Dexlansoprazole Delayed Release Capsule (30 and 60 mg)",
    "productDevStatus": "Ongoing",
    "pilotBE": "Pending",
    "scaleUp": "Pending",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Development Ongoing",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 8,
    "productID": "3039",
    "rLDProduct_Dev": "Zuplenz (USA)",
    "productName": "Ondenseteron Oral Dissolving Film (4 and 8 mg)",
    "productDevStatus": "Done",
    "pilotBE": "N/A",
    "scaleUp": "Pending",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Ready for Tech Transfer",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": false
      }
    ]
  },
  {
    "srno": 9,
    "productID": "3041",
    "rLDProduct_Dev": "Symbravo (USA)",
    "productName": "Meloxicam + Rizatriptan Benzoate (20 + 10 mg)",
    "productDevStatus": "Done",
    "pilotBE": "Pending",
    "scaleUp": "Pending",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Ready for Pilot BE",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 10,
    "productID": "3042",
    "rLDProduct_Dev": "AUVELITY (USA)",
    "productName": "Buproprion Extended Release (105 mg) + Dexmethrophen Hydrobromide (45 mg) Tablets",
    "productDevStatus": "Done",
    "pilotBE": "Done",
    "scaleUp": "Pending",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Ready For Tech Transfer",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 11,
    "productID": "3043",
    "rLDProduct_Dev": "NYMALIZE (USA)",
    "productName": "Nimodipine Oral Solution (6 mg/ml)",
    "productDevStatus": "Done",
    "pilotBE": "NA",
    "scaleUp": "Pending",
    "pivotalBE": "NA",
    "technologyTransfer": "Pending",
    "remark": "Alcohol Free. Ready For Tech Transfer",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 12,
    "productID": "3045",
    "rLDProduct_Dev": "Mylan (EU)",
    "productName": "Abiraterone Acetate Tablets (1000 mg)",
    "productDevStatus": "Done",
    "pilotBE": "Pending",
    "scaleUp": "Pending",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Ready for Pilot BE",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 13,
    "productID": "3049",
    "rLDProduct_Dev": "Venclexta (USA)",
    "productName": "Venetoclax Tablets 10,50,100 mg",
    "productDevStatus": "Pending",
    "pilotBE": "Ongoing",
    "scaleUp": "Pending",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Development Ongoing",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 14,
    "productID": "3050",
    "rLDProduct_Dev": "QUILLIVANT XR (USA)",
    "productName": "Methylphenedate ER Oral Suspension",
    "productDevStatus": "Ongoing",
    "pilotBE": "Pending",
    "scaleUp": "Pending",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Non Infringging",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 15,
    "productID": "3052",
    "rLDProduct_Dev": "Exxua (USA)",
    "productName": "Gepirione ER Tablets 18.2, 36.3, 54.5 and 72.6 mg",
    "productDevStatus": "Done",
    "pilotBE": "Done",
    "scaleUp": "Pending",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Pilot BE Ongoing. First to File Opprtunity.",
    "avaliableIn": [
      {
        "key": "USA",
        "value": false
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  }
];
